import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import type { VoteWindow } from "../../VoteWindow";
import { NewVoteController } from "../NewVoteController";

function useTimeCount(voteWindow: VoteWindow) {
    return useSyncExternalStore(voteWindow.subscribeTimeCount, voteWindow.getTimeCountSnapshot);
}

export function TimeController() {
    const { t } = useTranslation();
    const timeCount = useTimeCount(canv.appInterface.voteWindow);

    const handleChange = (time: number) => {
        canv.appInterface.voteWindow.setTimeCount(timeCount + time);
    };

    const handleInputChange = (time: number) => {
        canv.appInterface.voteWindow.setTimeCount(time);
    };

    return (
        <NewVoteController
            name={t("vote.time")}
            description={t("vote.timeMinutes")}
            count={timeCount}
            onChange={handleChange}
            onInputChange={handleInputChange}
        />
    );
}
